import { Button, Row, Statistic } from 'antd'
import SalesContribForm from '../../../../../../components/Corporate/Analytics/Reports/ReportsComponents/SalesContrib/SalesContribForm'
import ColStat from '../../../../../../elements/ColStat'
import RowStat from '../../../../../../elements/RowStat'
import _, { get } from 'lodash'
import { numVal } from '../../../../../../modules/Utils'
import React from 'react'

function SalesContribDisplay(props) {
  const { formRef, submitting, submit, data } = props
  return (
    <>
      <Row>
        <SalesContribForm ref={formRef} {...props} />
        <Button style={{ width: '100px' }} type="primary" loading={submitting} onClick={submit}>
          Submit
        </Button>
      </Row>
      {!_.isEmpty(data) && (
        <Row style={{ marginTop: 30, marginLeft: 30 }}>
          <RowStat>
            <ColStat>
              <Statistic title="Code" value={get(data, 'code')} />
            </ColStat>
            <ColStat>
              <Statistic title="Title" value={get(data, 'title')} />
            </ColStat>
          </RowStat>

          <RowStat>
            <ColStat>
              <Statistic title="Company Name" value={get(data, 'company.fn')} />
            </ColStat>
            <ColStat>
              <Statistic title="Client Name" value={get(data, 'client.fn')} />
            </ColStat>
          </RowStat>

          <RowStat>
            <ColStat>
              <Statistic title="Center Name" value={get(data, 'profit.name')} />
            </ColStat>
            <ColStat>
              <Statistic title="Center Category" value={get(data, 'profit.category')} />
            </ColStat>
          </RowStat>

          <RowStat>
            <ColStat>
              <Statistic
                title="Cost Total"
                value={numVal(data, 'cost.total')}
                precision={2}
                suffix="USD"
              />
            </ColStat>
            <ColStat>
              <Statistic
                title="Sales Total"
                value={numVal(data, 'sales.total')}
                precision={2}
                suffix="USD"
              />
            </ColStat>
          </RowStat>

          <RowStat>
            <ColStat>
              <Statistic
                title="Margin Total"
                value={numVal(data, 'margin.total')}
                precision={2}
                suffix="USD"
              />
            </ColStat>
            <ColStat>
              <Statistic
                title="Margin Percentage"
                value={get(data, 'margin.percentage')}
                precision={2}
                suffix="%"
              />
            </ColStat>
          </RowStat>
        </Row>
      )}
    </>
  )
}

export default SalesContribDisplay
